import { apiPatch } from '@/api/api.ts'
import { AlertPatchType } from '@/api/notification/alertServerValues.ts'
import { resetAlertHistoryCache } from '@/api/notification/alertHistoryCache.ts'

export interface IReqPatchFallDetectionAssignPerson {
    manager_name: string;
}

export const apiPatchFallDetectionAlertAssignPerson = async (id: number, params: IReqPatchFallDetectionAssignPerson) => {
    return await apiPatch<undefined>(`/alert/falldetection/${id}`, {
        type: AlertPatchType.ASSIGN,
        manager_name: params.manager_name
    })
}

export interface IReqPatchFallDetectionProcess {
    task_content: string;
    task_result: string;
}

export const apiPatchFallDetectionAlertProcess = async (id: number, params: IReqPatchFallDetectionProcess) => {
    const response = await apiPatch<undefined>(`/alert/falldetection/${id}`, {
        type: AlertPatchType.CONFIRM,
        task_result: params.task_result,
        task_content: params.task_content
    })

    if (Number(response.code) === 200) {
        await resetAlertHistoryCache('fall')
    }

    return response
}
